
import { motion } from 'framer-motion';

export default function GalleryHero() {
  return (
    <section className="relative pt-24 sm:pt-32 pb-16 sm:pb-24 bg-[#050505] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7df1388048f3c44cf215921e6cd2709d.jpg"
          alt="Galeria realizacji EUREKA"
          className="w-full h-full object-cover object-top opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/80 to-[#050505]"></div>
      </div>

      <div className="absolute top-1/4 left-1/4 w-[300px] sm:w-[500px] h-[300px] sm:h-[500px] bg-[#00E5FF]/5 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.25, 0.46, 0.45, 0.94] }}
          className="text-center"
        >
          <motion.span
            initial={{ opacity: 0, letterSpacing: '0.1em' }}
            animate={{ opacity: 1, letterSpacing: '0.3em' }}
            transition={{ duration: 1.2, delay: 0.2 }}
            className="inline-block text-[#00E5FF] text-xs sm:text-sm tracking-[0.3em] uppercase font-semibold mb-4 sm:mb-6"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Portfolio Realizacji
          </motion.span>

          <h1
            className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mt-2 leading-tight"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            <motion.span
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="block"
            >
              Nasze{' '}
              <span className="text-[#00E5FF]">Realizacje</span>
            </motion.span>
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
            className="text-sm sm:text-base lg:text-lg text-[#C0C7CF] mt-4 sm:mt-6 max-w-3xl mx-auto leading-relaxed px-2"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Ponad 35 lat doświadczenia w realizacji projektów przemysłowych najwyższej klasy.
            Każdy projekt to dowód naszej precyzji, technologii i niezawodności.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, scaleX: 0 }}
            animate={{ opacity: 1, scaleX: 1 }}
            transition={{ duration: 1, delay: 1 }}
            className="mt-8 sm:mt-10 flex flex-wrap items-center justify-center gap-4 sm:gap-8"
          >
            <div className="flex items-center gap-2 sm:gap-3">
              <span className="text-xl sm:text-3xl font-bold text-[#00E5FF]" style={{ fontFamily: 'Orbitron, sans-serif' }}>200+</span>
              <span className="text-[10px] sm:text-sm text-[#C0C7CF] text-left" style={{ fontFamily: 'Inter, sans-serif' }}>Zrealizowanych<br />projektów</span>
            </div>
            <div className="w-px h-8 sm:h-10 bg-[#00E5FF]/30 hidden sm:block"></div>
            <div className="flex items-center gap-2 sm:gap-3">
              <span className="text-xl sm:text-3xl font-bold text-[#00E5FF]" style={{ fontFamily: 'Orbitron, sans-serif' }}>35+</span>
              <span className="text-[10px] sm:text-sm text-[#C0C7CF] text-left" style={{ fontFamily: 'Inter, sans-serif' }}>Lat<br />doświadczenia</span>
            </div>
            <div className="w-px h-8 sm:h-10 bg-[#00E5FF]/30 hidden sm:block"></div>
            <div className="flex items-center gap-2 sm:gap-3">
              <span className="text-xl sm:text-3xl font-bold text-[#00E5FF]" style={{ fontFamily: 'Orbitron, sans-serif' }}>50+</span>
              <span className="text-[10px] sm:text-sm text-[#C0C7CF] text-left" style={{ fontFamily: 'Inter, sans-serif' }}>Klientów<br />przemysłowych</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
